import { render, staticRenderFns } from "./RuyuanAndChuyuanKepu.vue?vue&type=template&id=7f27f8e4&scoped=true"
import script from "./RuyuanAndChuyuanKepu.vue?vue&type=script&lang=js"
export * from "./RuyuanAndChuyuanKepu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f27f8e4",
  null
  
)

export default component.exports